import { isEmpty } from 'lodash-es';
import { IFilterList } from 'wisestep-base';

import ICareerBuilderAdvanceSearch from '../types/ICareerBuilderAdvanceSearch';

export const pushSearchFilters = (data: ICareerBuilderAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.jobTitle.values))
    filtersArray.push({
      tag: `Job Titles: ${data.jobTitle.values.join(',')}`,
      id: 'jobTitle',
    });
  if (!isEmpty(data.companies.values))
    filtersArray.push({
      tag: `Companies: ${data.companies.values.join(',')}`,
      id: 'companies',
    });
  // if (!isEmpty(data.zipcode))
  //   filtersArray.push({
  //     tag: `Zipcode: ${data.zipcode}`,
  //     id: 'zipcode',
  //   });
  if (!isEmpty(data.totalExperience?.min))
    filtersArray.push({
      tag: `Experience: ${data.totalExperience.min}-${data.totalExperience.max}`,
      id: 'totalExperience',
    });
  if (!isEmpty(data.minimumDegree))
    filtersArray.push({
      tag: `Minimum Degree: ${data.minimumDegree.join(',')}`,
      id: 'minimumDegree',
    });
  if (!isEmpty(data.languages))
    filtersArray.push({
      tag: `Languages: ${data.languages.join(',')}`,
      id: 'languages',
    });
  if (!isEmpty(data.employmentType))
    filtersArray.push({
      tag: `Employment Type: ${data.employmentType.join(',')}`,
      id: 'employmentType',
    });
  if (!isEmpty(data.workAuthorization))
    filtersArray.push({
      tag: `Work Authorization: ${data.workAuthorization.join(',')}`,
      id: 'workAuthorization',
    });
  if (!isEmpty(data.authorizedCountries))
    filtersArray.push({
      tag: `Countries: ${data.authorizedCountries.join(',')}`,
      id: 'authorizedCountries',
    });
  if (data.hasSecurityClearance)
    filtersArray.push({
      tag: 'Has Security Clearance',
      id: 'hasSecurityClearance',
    });
  if (data.currentlyEmployed?.toString() !== '')
    filtersArray.push({
      tag: `Currently Employed: ${data.currentlyEmployed}`,
      id: 'currentlyEmployed',
    });
  if (data.managementExperience?.toString() !== '')
    filtersArray.push({
      tag: `Management Experience: ${data.managementExperience}`,
      id: 'managementExperience',
    });
  if (!isEmpty(data.militaryExperience))
    filtersArray.push({
      tag: `Military Experience: ${data.militaryExperience.join(',')}`,
      id: 'militaryExperience',
    });
  if (data.minEmployeeManaged)
    filtersArray.push({
      tag: `Minimum Employee Managed: ${data.minEmployeeManaged}`,
      id: 'minEmployeeManaged',
    });
  if (data.salaryRange) {
    if (data.salaryRange.unitTime) {
      filtersArray.push({
        tag: `Compensation Type: ${data.salaryRange.unitTime}`,
        id: 'compensationType',
      });
    }
    if (data.salaryRange.min) {
      filtersArray.push({
        tag: `Minimum Salary: ${data.salaryRange.min}`,
        id: 'minimumSalary',
      });
    }
    if (data.salaryRange.max) {
      filtersArray.push({
        tag: `Maximum Salary: ${data.salaryRange.max}`,
        id: 'maximumSalary',
      });
    }
  }
  if (data.travelPreference?.toString() !== '')
    filtersArray.push({
      tag: `Travel Preference: ${data.travelPreference}`,
      id: 'travelPreference',
    });

  return filtersArray;
};
